import api from "../../config/apiConfig";
import { UserId } from "../../models/userId.model";


const investorReports = async (data: any) => {
    const accessToken = localStorage.getItem("accessToken");
    const response = await api.post("admin/rm/reports", data, {
        headers: {
            Authorization: accessToken, // Ensure the token is formatted correctly
        },
    });
    return response;  
}

const investmentReports = async (data: any) => {
    const accessToken = localStorage.getItem("accessToken");
    const response = await api.post("admin/rm/investment-reports", data, {
        headers: {
            Authorization: accessToken, // Ensure the token is formatted correctly
        },
    });
    return response;  
}

const reportsService = { investorReports, investmentReports };
export default reportsService;
